module.exports = __webpack_public_path__ + "img/Aasen_Omsetjar_og_spraakonsulent.8c102fdb.jpg";